import { Box } from '@material-ui/core'

import ToggleableSection from 'components/ToggleableSection'
import { useAppSelector } from 'store'
import { isMedianIncomeSegmentationEnabled } from 'store/feature-toggle'

import { withContext } from '../Context'
import FirstGenSelector from '../FirstGenSelector'
import EthnicitySelector from './EthnicitySelector'
import MedianIncomeSelector from './MedianIncomeSelector'
import NeighborhoodIncomeSelector from './NeighborhoodIncomeSelector'
import RaceSelector from './RaceSelector'

export const DemographicsSelector = () => {
  const isRaceAndEthnicityEnabled = useAppSelector(
    (state) => state.college.record?.Features?.SupportsRaceAndEthnicitySegmentation || false,
  )
  const isGranularMedianIncome = useAppSelector(
    (state) => state.college.record?.Features?.SupportsGranularMedianIncome || false,
  )
  const isMedianIncomeEnabled = useAppSelector(isMedianIncomeSegmentationEnabled)

  return (
    <ToggleableSection title="Demographics">
      {isMedianIncomeEnabled ? (
        <MedianIncomeSelector isGranular={isGranularMedianIncome} />
      ) : (
        <NeighborhoodIncomeSelector />
      )}
      <FirstGenSelector />
      {isRaceAndEthnicityEnabled && (
        <Box
          pt={2}
          gridGap={8}
          display="flex"
          flexDirection="column"
        >
          <RaceSelector />
          <EthnicitySelector />
        </Box>
      )}
    </ToggleableSection>
  )
}

export default withContext(DemographicsSelector)
